import PropTypes from 'prop-types';
import InlineSvg from 'Shared/components/inline-svg';
import styles from './tab-link.css';


const TabLink = ({
  show,
  text,
  action,
  content,
}) => (show && (
  <div className={styles.container}>
    <div
      className={styles.mainContainer}
      onClick={action}
    >
      <div className={styles.mainContentContainer}>
        <span>{text}</span>
        <InlineSvg src="/caret-right.svg" />
      </div>
    </div>
    {content && (
      <div className={styles.additionalContentContainer}>
        {content}
      </div>
    )}
  </div>
));

TabLink.propTypes = {
  show: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  content: PropTypes.node,
};

export default TabLink;
